import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Bug({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M11 8.5L10 7.5M13 8.5L14 7.5M17 9.5C14.23 12.26 9.76 12.26 7 9.5M8.85 14.67V14.669C8.16 14.999 7.53 15.449 6.99 15.989M17 16C16.45 15.45 15.83 15 15.14 14.67M8.25 12.75H6.5M17.5 12.75H15.75M12 8.5C11.0054 8.5 10.0516 8.92143 9.34835 9.67157C8.64509 10.4217 8.25 11.4391 8.25 12.5C8.25 13.5609 8.64509 14.5783 9.34835 15.3284C10.0516 16.0786 11.0054 16.5 12 16.5C12.9946 16.5 13.9484 16.0786 14.6517 15.3284C15.3549 14.5783 15.75 13.5609 15.75 12.5C15.75 11.4391 15.3549 10.4217 14.6517 9.67157C13.9484 8.92143 12.9946 8.5 12 8.5ZM8 3H16C18.7614 3 21 5.23858 21 8V16C21 18.7614 18.7614 21 16 21H8C5.23858 21 3 18.7614 3 16V8C3 5.23858 5.23858 3 8 3Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default Bug;